import Header from '../../components/Header'
import IngredientsList from '../../components/IngredientsList'

const Ingredients = () => (
  <>
    <Header />
    <div className="container">
      <IngredientsList></IngredientsList>
    </div>
  </>
)

export default Ingredients
